import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_StringAdapter1plpsgiy8rwhj as get_StringAdapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GrantSlackAccessInput3j0s7of1xul8d as GrantSlackAccessInput } from '../GrantSlackAccessInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GrantSlackAccessInput_InputAdapterClass;
function GrantSlackAccessInput_InputAdapter() {
  if (GrantSlackAccessInput_InputAdapterClass === VOID) {
    class $ {
      z3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      x6p(writer, customScalarAdapters, value) {
        writer.c48('code');
        get_StringAdapter().a40(writer, customScalarAdapters, value.j6n_1);
        writer.c48('state');
        get_StringAdapter().a40(writer, customScalarAdapters, value.k6n_1);
      }
      a40(writer, customScalarAdapters, value) {
        return this.x6p(writer, customScalarAdapters, value instanceof GrantSlackAccessInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'GrantSlackAccessInput_InputAdapter', VOID, VOID, [Adapter()]);
    GrantSlackAccessInput_InputAdapterClass = $;
  }
  return GrantSlackAccessInput_InputAdapterClass;
}
var GrantSlackAccessInput_InputAdapter_instance;
function GrantSlackAccessInput_InputAdapter_getInstance() {
  return GrantSlackAccessInput_InputAdapter_instance;
}
//region block: init
GrantSlackAccessInput_InputAdapter_instance = new (GrantSlackAccessInput_InputAdapter())();
//endregion
//region block: exports
export {
  GrantSlackAccessInput_InputAdapter_instance as GrantSlackAccessInput_InputAdapter_instancee259p9mrfnik,
};
//endregion

//# sourceMappingURL=GrantSlackAccessInput_InputAdapter.mjs.map
